import { Empty, Form, Input, Radio } from 'antd';
import { observer } from 'mobx-react';
import { RadioChangeEvent } from 'antd/lib/radio/interface';
import { useMst } from '@models/Root';
import { LocationBlocksProps } from '@modules/timetable';
import dynamic from 'next/dynamic';
import { ChangeEvent, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';

const SimpleBar = dynamic(() => import('simplebar-react'));

export const LocationBlocks = observer(({ locationData }: LocationBlocksProps) => {
  const { selectedDraggableItem, setSelectedLocation, selectedLocation, selectedTimelineItem } = useMst().timetable;
  const [locationDataList, setLocationDataList] = useState(locationData);
  if (locationData.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <>
      <Form.Item>
        <Input
          style={{ width: '300px' }}
          placeholder="Search Locations"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            if (event.target.value) {
              setLocationDataList(() => {
                let filteredArray = [];
                filteredArray = locationData.filter((location) =>
                  location.name.toLowerCase().includes((event.target.value as string).toLowerCase()),
                );
                return _.isEmpty(filteredArray) ? [] : filteredArray;
              });
            } else {
              setLocationDataList(locationData);
            }
          }}
          suffix={<SearchOutlined />}
        />
      </Form.Item>
      <SimpleBar style={{ maxHeight: 134 }}>
        <Radio.Group
          onChange={(event: RadioChangeEvent) => {
            setSelectedLocation(event.target.value);
          }}
          disabled={!selectedDraggableItem && !selectedTimelineItem}
          value={selectedLocation}
        >
          {locationDataList.map((location) => (
            <>
              <Radio key={location.id} value={location.id}>
                <div
                  className="location-color-dot"
                  style={{
                    backgroundColor: `${location.color}`,
                  }}
                />
                {location.name}
              </Radio>
              <br />
            </>
          ))}
        </Radio.Group>
      </SimpleBar>
    </>
  );
});
